const _config = {
    API_URL: process.env.REACT_APP_API_URL,
    COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME,
    MQTT_WEBSOCKET_URL: process.env.REACT_APP_MQTT_WEBSOCKET_URL,
    STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
    USER_NAME: process.env.REACT_APP_USER_NAME,
    PASSWORD: process.env.REACT_APP_PASSWORD,
    AUTH_BACKEND: process.env.REACT_APP_AUTH_BACKEND,
    GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL,
    FRONT_END_URL: process.env.REACT_FRONT_END_URL || "https://admin.airebrokers.com",
};

const config = {
    get(key) {
        const value = _config[key];
        return value;
    },
};

export default config;
